import { render, staticRenderFns } from "./ServiceHistoryTab.vue?vue&type=template&id=3474eb74&scoped=true"
import script from "./ServiceHistoryTab.vue?vue&type=script&lang=js"
export * from "./ServiceHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./ServiceHistoryTab.vue?vue&type=style&index=0&id=3474eb74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3474eb74",
  null
  
)

export default component.exports